import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = [
  "CULTURE",
  "FLAVOUR",
  "IDENTITY",
  "AUTHENTIC KITCHEN",
  "GLOBAL CUISINE",
  "GTA",
];

export const EditorialMarquee = () => {
  return (
    <section
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="relative bg-stone-950 border-y border-stone-900 py-10 overflow-hidden"
    >
      <Marquee gradient={false} speed={40} pauseOnHover={false}>
        {WORDS.concat(WORDS).map((w, i) => (
          <span
            key={i}
            className="inline-flex items-center font-serif-display text-stone-600 hover:text-orange-500 transition-colors text-4xl sm:text-5xl lg:text-6xl tracking-wide italic mx-8"
          >
            {w}
            <span className="mx-10 text-orange-600 not-italic">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
